var OrderHeader = /** @class */ (function () {
    function OrderHeader() {
        this.appOrderId = 0;
        this.userName = '';
        this.orderState = 0;
        this.navorderId = '';
        this.orderType = '';
        this.sellToCustomerNo = null;
        this.sellToCustomerName = null;
        this.sellToCustomerName2 = null;
        this.sellToAddress = null;
        this.sellToAddress2 = null;
        this.sellToCity = null;
        this.sellToContact = null;
        this.sellToPostCode = null;
        this.sellToCounty = null;
        this.sellToCountry_RegionCode = null;
        this.sellToPhone = null;
        this.sellToContactEMail = null;
        this.shipToCode = null;
        this.shipToName = null;
        this.shipToName2 = null;
        this.shipToAddress = null;
        this.shipToAddress2 = null;
        this.shipToCity = null;
        this.shipToContact = null;
        this.shipToPostCode = null;
        this.shipToCounty = null;
        this.shipToCountry_RegionCode = null;
        this.shipTo_Firstname = null;
        this.shipTo_Lastname = null;
        this.shippingComment = null;
        this.shipToEMail = null;
        this.shipToPhone = null;
        this.currencyCode = null;
        this.salesPersonCode = null;
        this.orderLinediscount = null;
        this.orderComment = null;
        this.orderAccessId = null;
        this.vatRegistrationNo = null;
        this.orderIsFinal = false;
        this.orderNeedsFollowUp = false;
        this.externalDocumentNo = null;
        this.salespersonNote = null;
        this.poOpen = null;
        this.poClosed = null;
        this.removeFreigth = false;
        this.navImportRef = null;
        this.createdUtc = null;
        this.removeHandlingFee = false;
    }
    OrderHeader.buildFromSalesbook = function (data) {
        var orderHeader = new OrderHeader();
        orderHeader.appOrderId = data.apporderid;
        orderHeader.userName = data.salesbookuser;
        orderHeader.orderState = data.orderstate;
        orderHeader.navorderId = data.navorderid;
        orderHeader.orderType = data.ordertype;
        orderHeader.sellToCustomerNo = data.selltocustomerno;
        orderHeader.sellToCustomerName = data.selltocustomername;
        orderHeader.sellToCustomerName2 = data.selltocustomername2;
        orderHeader.sellToAddress = data.selltoaddress;
        orderHeader.sellToAddress2 = data.selltoaddress2;
        orderHeader.sellToCity = data.selltocity;
        orderHeader.sellToContact = data.selltocontact;
        orderHeader.sellToPostCode = data.selltopostcode;
        orderHeader.sellToCounty = data.selltocounty;
        orderHeader.sellToCountry_RegionCode = data.selltocountry_regioncode;
        orderHeader.sellToPhone = data.selltophone;
        orderHeader.sellToPhone = data.selltophone;
        orderHeader.sellToContactEMail = data.selltocontactemail;
        orderHeader.shipToCode = data.shiptocode;
        orderHeader.shipToName = data.shiptoname;
        orderHeader.shipToName2 = data.shiptoname2;
        orderHeader.shipToAddress = data.shiptoaddress;
        orderHeader.shipToAddress2 = data.shiptoaddress2;
        orderHeader.shipToCity = data.shiptocity;
        orderHeader.shipToContact = data.shiptocontact;
        orderHeader.shipToPostCode = data.shipToPostCode;
        orderHeader.shipToCounty = data.shiptocounty;
        orderHeader.shipToCountry_RegionCode = data.shiptocountry_regioncode;
        orderHeader.shipTo_Firstname = data.shipto_firstname;
        orderHeader.shipTo_Lastname = data.shipto_lastname;
        orderHeader.shippingComment = data.shippingcomment;
        orderHeader.shipToEMail = data.shiptoemail;
        orderHeader.shipToPhone = data.shiptophone;
        orderHeader.currencyCode = data.currencycode;
        orderHeader.salesPersonCode = data.salespersoncode;
        orderHeader.orderLinediscount = data.orderlinediscount;
        orderHeader.orderComment = data.ordercomment;
        orderHeader.orderAccessId = data.orderaccessid;
        orderHeader.vatRegistrationNo = data.vatregistrationno;
        orderHeader.orderIsFinal = data.orderisfinal;
        orderHeader.orderNeedsFollowUp = data.orderneedsfollowup;
        orderHeader.externalDocumentNo = data.externaldocumentno;
        orderHeader.salespersonNote = data.salespersonnote;
        orderHeader.poOpen = data.poopen;
        orderHeader.poClosed = data.poclosed;
        orderHeader.removeFreigth = data.removefreigth;
        orderHeader.navImportRef = data.navimportref;
        orderHeader.removeHandlingFee = !!data.removehandeligfee;
        return orderHeader;
    };
    OrderHeader.buildFromB2B = function (data) {
        var orderHeader = new OrderHeader();
        orderHeader.appOrderId = data.appOrderId;
        orderHeader.createdUtc = data.createdUtc;
        orderHeader.userName = data.salesbookuser || '';
        orderHeader.orderState = data.orderState;
        orderHeader.navorderId = data.navorderId;
        orderHeader.orderType = data.orderType;
        orderHeader.sellToCustomerNo = data.sellToCustomerNo;
        orderHeader.sellToCustomerName = data.sellToCustomerName;
        orderHeader.sellToCustomerName2 = data.sellToCustomerName2;
        orderHeader.sellToAddress = data.sellToAddress;
        orderHeader.sellToAddress2 = data.sellToAddress2;
        orderHeader.sellToCity = data.sellToCity;
        orderHeader.sellToContact = data.sellToContact;
        orderHeader.sellToPostCode = data.sellToPostCode;
        orderHeader.sellToCounty = data.selltocounty;
        orderHeader.sellToCountry_RegionCode = data.sellToCounty;
        orderHeader.sellToPhone = data.selltophone;
        orderHeader.sellToPhone = data.sellToPhone;
        orderHeader.sellToContactEMail = data.sellToContactEMail;
        orderHeader.shipToCode = data.shipToCode;
        orderHeader.shipToName = data.shipToName;
        orderHeader.shipToName2 = data.shipToName2;
        orderHeader.shipToAddress = data.shipToAddress;
        orderHeader.shipToAddress2 = data.shipToAddress2;
        orderHeader.shipToCity = data.shipToCity;
        orderHeader.shipToContact = data.shipToContact;
        orderHeader.shipToPostCode = data.shipToPostCode;
        orderHeader.shipToCounty = data.shipToCounty;
        orderHeader.shipToCountry_RegionCode = data.shipToCountry_RegionCode;
        orderHeader.shipTo_Firstname = data.shipTo_Firstname;
        orderHeader.shipTo_Lastname = data.shipTo_Lastname;
        orderHeader.shippingComment = data.shippingComment;
        orderHeader.shipToEMail = data.shipToEMail;
        orderHeader.shipToPhone = data.shipToPhone;
        orderHeader.currencyCode = data.shipToPhone;
        orderHeader.salesPersonCode = data.salesPersonCode;
        orderHeader.orderLinediscount = data.orderLinediscount;
        orderHeader.orderComment = data.orderComment;
        orderHeader.orderAccessId = data.orderAccessId;
        orderHeader.vatRegistrationNo = data.vatRegistrationNo;
        orderHeader.orderIsFinal = data.orderIsFinal;
        orderHeader.orderNeedsFollowUp = data.orderNeedsFollowUp;
        orderHeader.externalDocumentNo = data.externalDocumentNo;
        orderHeader.salespersonNote = data.salespersonNote;
        orderHeader.poOpen = data.poOpen;
        orderHeader.poClosed = data.poClosed;
        orderHeader.removeFreigth = data.removeFreigth;
        orderHeader.navImportRef = data.navImportRef;
        orderHeader.removeHandlingFee = !!data.removeHandlingFee;
        return orderHeader;
    };
    return OrderHeader;
}());
export { OrderHeader };
//# sourceMappingURL=OrderHeader.js.map